import { gql } from 'graphql.macro';

export const apiClientFieldsFragment = gql`
    fragment apiClientFields on ApiClient {
        _id
        organization
        name
        clientId
        mode
        scopes
        disabled
        lastUsedAt
        secretLastRotatedAt
        createdBy
        createdAt
        updatedAt
    }
`;

export const getApiClientsForOrganizationTemplate = gql`
    query apiClientsForOrganization($organizationId: MongoDbObjectId!) {
        apiClientsForOrganization(organizationId: $organizationId) {
            ...apiClientFields
        }
    }
    ${apiClientFieldsFragment}
`;
